import { API_URL } from '../../../app-config/constants';
import type AuditRecordDto from '../../../types/AuditRecordDto';
import { get } from '../request';

getLog.operation = 'READ';
getLog.byId = true;
export function getLog(id: string) {
    return get<AuditRecordDto>(`${API_URL}/audit-record/${id}`);
}
